import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import './TextBox.scss';
import { TranslationUtils } from '../../utils';

interface TextBoxProps {
    title?: string;
    text: string;
    maxLength: number;
    inline?: boolean;
    classNote?: string;
    classTitle?: string;
}

export const TextBox: React.FC<TextBoxProps> = (props) => {
    let { title, text, maxLength, classNote, classTitle, inline } = props;
    const lesserMl = text.indexOf(' ', maxLength);
    const limit = lesserMl === -1 ? maxLength : lesserMl;
    const shouldCollapse = text.length > limit;
    const [isShowingCollapsed, setIsShowCollapsed] = useState<boolean>(false);
    const trimmedTextAsHTML = text.substr(0, limit).replace(/\n/g, '<br />');
    const remainingTextAsHTML = text.substr(limit, text.length).replace(/\n/g, '<br />');
    return (
        <div className="text-box">
            {title && <h3 className={classTitle ? classTitle : 'box-title'}>{title}</h3>}
            <p className={classNote ? classNote : 'box-text'}>
                <div dangerouslySetInnerHTML={{ __html: trimmedTextAsHTML }} />
                <Collapse in={isShowingCollapsed}>
                    <span className={classNote ? classNote : 'box-text'}>
                        <div dangerouslySetInnerHTML={{ __html: remainingTextAsHTML }} />
                    </span>
                </Collapse>
                {inline && <br />}
                <span
                    className={shouldCollapse ? 'body-small collapse-toggle pointer' : 'hidden'}
                    onClick={() => setIsShowCollapsed(!isShowingCollapsed)}
                >
                    {TranslationUtils.get(`${isShowingCollapsed ? 'read_less' : 'read_more'}`)}
                </span>
            </p>
        </div>
    );
};
